import script from "./BookADemo.vue?vue&type=script&setup=true&lang=js"
export * from "./BookADemo.vue?vue&type=script&setup=true&lang=js"

import "./BookADemo.vue?vue&type=style&index=0&id=0bd8a5c1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd8a5c1"]])

export default __exports__